import {OtherSystemCategory} from '../api/authority/generated/models/OtherSystemCategory.ts';

export function otherSystemCategoryLabel(t, category) {
    switch (category) {
        case OtherSystemCategory.OtherMedia:
            return t('other-sources.categories.OtherMedia');
        case OtherSystemCategory.ContentAndProduction:
            return t('other-sources.categories.ContentAndProduction');
        case OtherSystemCategory.AgencyServices:
            return t('other-sources.categories.AgencyServices');
        case OtherSystemCategory.ToolsAndLicenses:
            return t('other-sources.categories.ToolsAndLicenses');
        case OtherSystemCategory.OfflineEventsAndPromotions:
            return t('other-sources.categories.OfflineEventsAndPromotions');
        case OtherSystemCategory.InternalShipping:
            return t('other-sources.categories.InternalShipping');
        case OtherSystemCategory.PackagingVariable:
            return t('other-sources.categories.PackagingVariable');
        case OtherSystemCategory.PackagingFixed:
            return t('other-sources.categories.PackagingFixed');
        case OtherSystemCategory.Other:
            return t('other-sources.categories.Other');
        default:
            return category ?? '—';
    }
}

export function getOtherSystemCategoryOptions(t) {
    return [
        OtherSystemCategory.OtherMedia,
        OtherSystemCategory.ContentAndProduction,
        OtherSystemCategory.AgencyServices,
        OtherSystemCategory.ToolsAndLicenses,
        OtherSystemCategory.OfflineEventsAndPromotions,
        OtherSystemCategory.InternalShipping,
        OtherSystemCategory.PackagingVariable,
        OtherSystemCategory.PackagingFixed,
        OtherSystemCategory.Other,
    ].map((value) => ({value, label: otherSystemCategoryLabel(t, value)}));
}
